import React from "react";
import Image from "next/image";

const DoctorMobileClinicalUSA = () => {
  return (
    <>
      <div className="bg-white py-6 px-3">
        <div className="flex items-center justify-center gap-2">
          <Image
            src="/healthcare/doctors/Celender.png"
            alt="calender"
            width={18}
            height={18}
          />
          <p className="text-base text-[#1772EA] font-semibold tracking-[-0.64px]">
            Years 4-5
          </p>
        </div>
        <h2 className="text-center text-[28px] leading-[1.1] font-semibold tracking-[-1.12px] text-black mt-2">
          Complete Clinical <br />
          Rotations in{" "}
          <span className="md:pb-0 bg-[linear-gradient(96deg,#39f_8.49%,#ffba08_87.26%)] bg-clip-text text-transparent [-webkit-text-fill-color:transparent] inline-block pr-[5px] italic">
            USA
          </span>
        </h2>
        <p className="text-center text-sm text-black tracking-[-0.56px] mt-2">
          In partnership with{" "}
          <span className="font-bold">88 top American hospitals</span>
        </p>
        <div className="flex md:flex-row flex-col justify-center items-center gap-6 mt-6">
          <div className="text-center md:w-[50%] w-full">
            <div className="doc_sh rounded-[10px] p-4 w-full border border-[#39f]">
              <h2 className="text-[#1772ea] text-[20px] font-semibold mb-4">
                St. George's University
              </h2>
              <div className="flex justify-center w-full gap-3 flex-wrap">
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/g1.png"
                    alt="Special Offer"
                    className="mx-auto grayscale"
                    width={160}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Weston, FL
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/g2.png"
                    alt="Special Offer"
                    className="mx-auto grayscale"
                    width={160}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Hackensack, NJ
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/g3.png"
                    alt="Special Offer"
                    className="mx-auto grayscale"
                    width={160}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    New Rochelle, NY
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/g4.png"
                    alt="Special Offer"
                    className="mx-auto grayscale"
                    width={160}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Morristown, NJ
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/g5.png"
                    alt="Special Offer"
                    className="mx-auto grayscale"
                    width={160}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Bronx, NY
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/g6.png"
                    alt="Special Offer"
                    className="mx-auto grayscale"
                    width={160}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Brooklyn, NY
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/g7.png"
                    alt="Special Offer"
                    className="mx-auto grayscale"
                    width={160}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Brooklyn, NY
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/g8.png"
                    alt="Special Offer"
                    className="mx-auto grayscale"
                    width={160}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Queens, NY
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/g9.png"
                    alt="Special Offer"
                    className="mx-auto grayscale"
                    width={160}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Paterson, NJ
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/g10.png"
                    alt="Special Offer"
                    className="mx-auto grayscale"
                    width={160}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    New Brunswick, NJ
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/g11.png"
                    alt="Special Offer"
                    className="mx-auto w-[50px] grayscale"
                    width={160}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Livingston, NJ
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/g12.png"
                    alt="Special Offer"
                    className="mx-auto grayscale"
                    width={160}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Queens, NY
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center md:w-[50%] w-full">
            <div className="doc_sh rounded-[10px] p-4 w-full border border-[#1772ea]">
              <h2 className="text-[#1772ea] text-[20px] font-semibold mb-4">
                Saint James School of Medicine
              </h2>
              {/* <Image
                src="/healthcare/doctors/Saint_James_School.png"
                height={430}
                width={650}
                alt="Saint James School of Medicine"
                className="w-full"
              /> */}
              <div className="flex justify-center w-full gap-3 flex-wrap">
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/u1.png"
                    alt="Special Offer"
                    className="mx-auto w-[68%] grayscale"
                    width={130}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Edinburg, TX
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/u2.png"
                    alt="Special Offer"
                    className="mx-auto w-[68%] grayscale"
                    width={130}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Olympia Fields, Il
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/u3.png"
                    alt="Special Offer"
                    className="mx-auto w-[68%] grayscale"
                    width={130}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Chicago, Il
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/u4.png"
                    alt="Special Offer"
                    className="mx-auto w-[68%] grayscale"
                    width={130}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    West Islip , NY
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/u5.png"
                    alt="Special Offer"
                    className="mx-auto w-[68%] grayscale"
                    width={130}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Bay City , MI
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/u6.png"
                    alt="Special Offer"
                    className="mx-auto w-[68%] grayscale"
                    width={130}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Edinburg, TX
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/u7.png"
                    alt="Special Offer"
                    className="mx-auto w-[68%] grayscale"
                    width={130}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Waterbury, CT
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/u8.png"
                    alt="Special Offer"
                    className="mx-auto w-[36%] grayscale"
                    width={130}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Beckley, WV
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/u9.png"
                    alt="Special Offer"
                    className="mx-auto w-[68%] grayscale"
                    width={130}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Foley, AL
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/u10.png"
                    alt="Special Offer"
                    className="mx-auto w-[68%] grayscale"
                    width={130}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Edinburg, TX
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/u11.png"
                    alt="Special Offer"
                    className="mx-auto w-[68%] grayscale"
                    width={130}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    Edinburg, TX
                  </p>
                </div>
                <div className="bg-white w-[30%] h-[67px] flex flex-col justify-between py-3 px-2 shadow-[0px_3.472px_6.944px_0px_rgba(4,84,175,0.25)] text-center">
                  <Image
                    src="/healthcare/doctors/u12.png"
                    alt="Special Offer"
                    className="mx-auto w-[68%] grayscale"
                    width={130}
                    height={32}
                    loading="lazy"
                  />
                  <p className="text-[8px] font-bold text-[#1772ea]">
                    McAllen, TX
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorMobileClinicalUSA;
